import React from "react";

import {
 Card,
 CardBody,
 Table
} from "reactstrap";

const OutstandingBookings = ({
 bookings=[]
}) => {

 return (

  <Card>

   <CardBody>

    <h5>
     Outstanding Dues
    </h5>

    <Table responsive>

     <thead>

      <tr>

       <th>
        Booking ID
       </th>

       <th>
        Guest
       </th>

       <th>
        Room
       </th>

       <th>
        Due
       </th>

      </tr>

     </thead>

     <tbody>

      {bookings.map(
       (item,index)=>(
        <tr key={index}>

         <td>
          {item.bookingId}
         </td>

         <td>
          {item.guest}
         </td>

         <td>
          {item.room}
         </td>

         <td>
          ₹
          {item.balance.toLocaleString()}
         </td>

        </tr>
       )
      )}

     </tbody>

    </Table>

   </CardBody>

  </Card>

 );

};

export default OutstandingBookings;